module.exports = __webpack_public_path__ + "img/create_first_campaign.2c919fc0.png";